import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IServerTime, TimeDataType } from 'apis/types';
import { RootState } from 'app/store';
import { isValidServerTimeData, SESSION_CURRENT_TIME, SessionStorage } from 'utils';

export interface TimeState {
  loading: boolean;
  data: TimeDataType;
}
const initialState: TimeState = {
  loading: true,
  data: { business_date: '', tm_hh_mm: '' },
};

const timeSlice = createSlice({
  name: 'time',
  initialState,
  reducers: {
    fetchTimeData(state) {
      state.loading = true;
    },
    fetchTimeDataSuccess(state, action: PayloadAction<IServerTime>) {
      state.loading = false;

      if (!isValidServerTimeData(action.payload.data)) return;

      state.data = {
        business_date: action.payload.data.business_date,
        tm_hh_mm: action.payload.data.tm_hh_mm,
        is_holiday: action.payload.data.is_holiday,
      };
      SessionStorage.setItem(SESSION_CURRENT_TIME, state.data.tm_hh_mm);
    },
    fetchTimeDataFailed(state) {
      state.loading = false;
    },
  },
});

// Actions
export const timeActions = timeSlice.actions;
// Selectors
export const selectTimeLoading = (state: RootState) => state.time.loading;
export const selectTime = (state: RootState) => state.time.data;
// Reducer
export const timeReducer = timeSlice.reducer;
